export const COMPANIES = 'COMPANIES'